import { Icon } from "@iconify/react/dist/iconify.js";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { updateStudent } from "../server/institutionAllApi";
import { Snackbar, Alert, CircularProgress } from "@mui/material";
import { Modal, Button, Form } from "react-bootstrap";

const EditStudent = () => {
  const [imagePreview, setImagePreview] = useState(
    "assets/images/user-grid/user-grid-img13.png"
  );
  const location = useLocation();
  const studentToEdit = location.state?.student;

  const [formState, setFormState] = useState({
    student_id: "",
    name: "",
    email: "",
    address: "",
    mobile: "",
    country_code: "",
    education: "",
    gender: "",
    visa_status: "",
  });
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [selectedLevel, setSelectedLevel] = useState("");
  const [selectedCourse, setSelectedCourse] = useState("");
  const [selectedCourseData, setSelectedCourseData] = useState("");
  const [selectedBatch, setSelectedBatch] = useState("");
  const [savedDepartmentName, setSavedDepartmentName] = useState("");
  const [savedLevelName, setSavedLevelName] = useState("");
  const [savedCourseName, setSavedCourseName] = useState("");
  const [savedBatchName, setSavedBatchName] = useState("");
  const [departments, setDepartments] = useState([]);
  const [levels, setLevels] = useState([]);
  const [courses, setCourses] = useState([]);
  const [batches, setBatches] = useState([]);
  const [selectedEducation, setSelectedEducation] = useState("");
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [cities, setCities] = useState([]);
  const [token, setToken] = useState("");
  const [selectedCity, setSelectedCity] = useState("");
  const [savedCountryName, setSavedCountryName] = useState("");
  const [savedStateName, setSavedStateName] = useState("");
  const [savedCityName, setSavedCityName] = useState("");
  const [isNameTouched, setIsNameTouched] = useState(false);
  const [isMobileTouched, setIsMobileTouched] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [imagePreviewUrl, setImagePreviewUrl] = useState("");
  const [certificateImage, setCertificateImage] = useState(null);
  const [isCompleted, setIsCompleted] = useState(false);
  const [selectedBatchToDate, setSelectedBatchToDate] = useState("");
  const [selectedBatchStartDate, setSelectedBatchStartDate] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showCopied, setShowCopied] = useState(false);
  const [enrolledCourseData, setEnrolledCourseData] = useState({});
  const [certificateImages, setCertificateImages] = useState({});
  const [imagePreviews, setImagePreviews] = useState({});
  const [asessments, setAssessments] = useState("");
  const [portfolios, setPortfolios] = useState("");
  const [attendences, setAttendences] = useState("");
  const [refferal, setRefferal] = useState("");
  const [roleName, setRoleName] = useState("");

  // modal
  const [showModal, setShowModal] = useState(false);
  const [selectedModalCourse, setSelectedModalCourse] = useState(null);
  const [amount, setAmount] = useState("");
  const [paymentMode, setPaymentMode] = useState("");
  const [paymentProof, setPaymentProof] = useState(null);
  const [showImageModal, setShowImageModal] = useState(false);
  const [modalImage, setModalImage] = useState("");
  const [showPaymentDetailsModal, setShowPaymentDetailsModal] = useState(false);
  const [selectedCoursePayments, setSelectedCoursePayments] = useState(null);
  // Add these state variables
  const [showCourseModal, setShowCourseModal] = useState(false);
  const [availableCourses, setAvailableCourses] = useState([]);
  const [purchaseLoading, setPurchaseLoading] = useState(null);

  // Add these functions
  const fetchAvailableCourses = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-Courses`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // Access the courses array from the data property
      setAvailableCourses(response.data.data || []);
    } catch (error) {
      console.error("Error fetching courses:", error);
      setSnackbarMessage("Failed to fetch available courses");
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
      setAvailableCourses([]); // Reset to empty array on error
    }
  };

  const handlePurchaseCourse = async (courseId) => {
    setPurchaseLoading(courseId);
    try {
      await axios.post(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/course/purchase`,
        {
          course_id: courseId,
          student_id: studentToEdit._id,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // Refresh the enrolled courses
      await getErolledStudentById(studentToEdit._id);

      setSnackbarMessage("Course purchased successfully");
      setSnackbarSeverity("success");
      setOpenSnackbar(true);
      setShowCourseModal(false);
    } catch (error) {
      console.error("Error purchasing course:", error);
      setSnackbarMessage(
        error.response?.data?.message || "Failed to purchase course"
      );
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
    } finally {
      setPurchaseLoading(null);
    }
  };
  const handleBatchAssigning = async (courseId, batchId) => {
    setPurchaseLoading(batchId);
    try {
      await axios.post(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/course/batch-assign`,
        {
          enrolled_course_id: courseId,
          batch_id: batchId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // Refresh the enrolled courses
      await getErolledStudentById(studentToEdit._id);

      setSnackbarMessage("Course purchased successfully");
      setSnackbarSeverity("success");
      setOpenSnackbar(true);
      setShowCourseModal(false);
    } catch (error) {
      console.error("Error purchasing course:", error);
      setSnackbarMessage(
        error.response?.data?.message || "Failed to purchase course"
      );
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
    } finally {
      setPurchaseLoading(null);
    }
  };

  // Add this useEffect
  useEffect(() => {
    if (showCourseModal) {
      fetchAvailableCourses();
    }
  }, [showCourseModal]);

  const navigate = useNavigate();

  const readURL = (input) => {
    if (input.target.files && input.target.files[0]) {
      const file = input.target.files[0];

      // Allowed image types
      const allowedTypes = [
        "image/png",
        "image/jpeg",
        "image/jpg",
        "image/gif",
      ];

      if (!allowedTypes.includes(file.type)) {
        setSnackbarMessage(
          "Invalid file format! Please upload an image (PNG, JPG, JPEG, GIF)."
        );
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
        return; // Stop further execution
      }

      // If valid image, read and preview it
      const reader = new FileReader();
      reader.onload = (e) => {
        setImagePreview(e.target.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const fetchRefferal = async () => {
    setLoading(true);
    setError(null);
    const token = localStorage.getItem("token");
    try {
      // if (!token) {
      //   // console.log("Access required");
      //   return;
      // }

      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/users-referrals-data`,
        {
          params: {
            id: studentToEdit?._id,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("response: attendence-----", response.data.data);

      setRefferal(response.data.data);
    } catch (error) {
      console.error("Failed to fetch Portfolios:", error);
      setError("Failed to fetch Portfolios.");
    } finally {
      setLoading(false);
    }
  };
  const fetchAttendence = async () => {
    setLoading(true);
    setError(null);
    const token = localStorage.getItem("token");
    try {
      // if (!token) {
      //   // console.log("Access required");
      //   return;
      // }

      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/zoom-meetings-attendence`,
        {
          params: {
            user_id: studentToEdit?._id,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log("response: attendence-----", response.data.data);

      setAttendences(response.data.data);
    } catch (error) {
      console.error("Failed to fetch Portfolios:", error);
      setError("Failed to fetch Portfolios.");
    } finally {
      setLoading(false);
    }
  };

  const fetchPortfolios = async () => {
    setLoading(true);
    setError(null);
    const token = localStorage.getItem("token");
    try {
      if (!token) {
        // console.log("Access required");
        return;
      }

      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-portfolios`,
        {
          params: {
            details_id: studentToEdit?._id,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // console.log("response: ", response.data.data);

      setPortfolios(response.data.data);
    } catch (error) {
      console.error("Failed to fetch Portfolios:", error);
      setError("Failed to fetch Portfolios.");
    } finally {
      setLoading(false);
    }
  };
  const fetchAssessments = async () => {
    setLoading(true);
    setError(null);
    const token = localStorage.getItem("token");
    try {
      if (!token) {
        // console.log("Access required");
        return;
      }

      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-assessment`,
        {
          params: {
            details_id: studentToEdit?._id,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // console.log("response: ", response.data.data);

      setAssessments(response.data.data);
    } catch (error) {
      console.error("Failed to fetch Assassments:", error);
      setError("Failed to fetch Assassments.");
    } finally {
      setLoading(false);
    }
  };
  const handleImageChange = async (e, courseId) => {
    const file = e.target.files[0];

    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreviews((prev) => ({
          ...prev,
          [courseId]: reader.result, // Store preview per course
        }));
        setCertificateImages((prev) => ({
          ...prev,
          [courseId]: file, // Store actual file per course
        }));

        // Call API to update image
        uploadImage(courseId, file);
      };
      reader.readAsDataURL(file);
    }
  };

  // Function to upload image to API
  const uploadImage = async (courseId, file) => {
    const formData = new FormData();
    formData.append("certificateImage", file);
    const token = localStorage.getItem("token");
    if (!token) {
      // console.log("Access required");
      return;
    }
    try {
      const response = await axios.put(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/enrolled-course-update-img/${courseId}`,
        formData, // Pass formData directly as the body
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status !== 200) {
        // console.log("Failed to upload image");
      } else {
        // console.log("Upload successful:", response.data);
      }
    } catch (error) {
      console.error("Error uploading image:", error);
    }
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  useEffect(() => {
    if (studentToEdit) {
      // console.log("student to edit: ", studentToEdit);
      fetchAssessments();
      fetchPortfolios();
      fetchAttendence();
      fetchRefferal();
      setFormState({
        student_id: studentToEdit?.student_id,
        name: studentToEdit?.name,
        email: studentToEdit?.email,
        address: studentToEdit?.address,
        // country: studentToEdit.country,
        country_code: studentToEdit.country_code,
        mobile: studentToEdit?.mobile,
        user_name: studentToEdit?.user_name,
        // roll_no: studentToEdit.roll_no,
        education: studentToEdit?.education,
        gender: studentToEdit?.gender,
        visa_status: studentToEdit?.visa_status,
        // state: studentToEdit.state
        // image: studentToEdit.profile_url
        // admission_Date: new Date(studentToEdit.admission_Date).toISOString().split("T")[0], // Format to YYYY-MM-DD
        // gender: studentToEdit.gender,
      });
      setImagePreview(studentToEdit?.profile_url);
      setSavedDepartmentName(studentToEdit?.department?.department_name);
      setSavedLevelName(studentToEdit?.level?.courseCategoryName);
      setSavedCourseName(studentToEdit?.courses?.coursename);
      setSavedBatchName(studentToEdit?.batches?.batch_name);
      setSelectedBatchToDate(studentToEdit?.batches?.batch_end_duration);
      setSelectedBatchStartDate(studentToEdit?.batches?.batch_start_duration);
      setSavedCountryName(studentToEdit?.countriesData?.name);
      setSavedStateName(studentToEdit?.statesData?.name);
      setSavedCityName(studentToEdit?.cityData?.name);
      setSelectedEducation(studentToEdit?.education);

      setSelectedDepartment(studentToEdit?.department?._id);
      setSelectedLevel(studentToEdit?.level?._id);
      setSelectedCourse(studentToEdit?.courses?._id);
      setSelectedCourseData(studentToEdit?.courses);
      setSelectedBatch(studentToEdit?.batches?._id);
      setSelectedCountry(studentToEdit?.countriesData?._id);
      setSelectedState(studentToEdit?.statesData?._id);
      setSelectedCity(studentToEdit?.cityData?._id);

      // console.log(
      //   "selected department: ",
      //   selectedDepartment,
      //   "selected level: ",
      //   selectedLevel,
      //   "selected course: ",
      //   selectedCourse
      // );

      getErolledStudentById(studentToEdit._id);

      //   setLoading(false); // Stop loading after setting form state
    } else {
      setError("No user data found.");
      //   setLoading(false);
    }
  }, [studentToEdit]);

  const getErolledStudentById = async (id) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        // console.log("Access required");
        return;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-enrolled-course-by-studentid/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // console.log("response: ", response.data.data[0]);
      if (response.status === 200) {
        setEnrolledCourseData(response.data.data);
        setIsCompleted(response?.data?.data[0]?.completed);
        setImagePreviewUrl(response?.data?.data[0]?.certificateImage);
      }
    } catch (error) {
      // console.log(error);
    }
  };

  useEffect(() => {
    const token1 = localStorage.getItem("token");
    setToken(token1);
    if (!token1) {
      // console.log("Access required");
      return;
    }

    const user = localStorage?.getItem("user");
    const parsedUser = JSON.parse(user);
    const role = parsedUser?.rolename;
    setRoleName(role);

    fetchBatches();
    fetchdCountry();
  }, []);

  useEffect(() => {
    fetchStatesByCountry();
  }, [selectedCountry]);

  useEffect(() => {
    fetchCityByState();
  }, [selectedState]);

  const fetchBatches = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        // console.log("Access required");
        return;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-batches`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setBatches(response?.data?.data);
      // console.log(response?.data?.data);
    } catch (error) {
      // console.log(error);
    }
  };

  const fetchdCountry = async () => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        // console.log("Access required");
        return;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-countries`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setCountries(response?.data?.data);
      // console.log(response?.data?.data);
    } catch (error) {
      // console.log(error);
    }
  };

  const fetchStatesByCountry = async () => {
    if (!selectedCountry) {
      return;
    }
    try {
      if (!token) {
        // console.log("Access required");
        return;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-states/${selectedCountry}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setStates(response?.data?.data);
      // console.log(response?.data?.data);
    } catch (error) {
      // console.log(error);
    }
  };

  const fetchCityByState = async () => {
    if (!selectedState) {
      return;
    }
    try {
      if (!token) {
        // console.log("Access required");
        return;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/get-all-cities/${selectedState}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setCities(response?.data?.data);
      // console.log(response?.data?.data);
    } catch (error) {
      // console.log(error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormState({
      ...formState,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formState?.name && formState?.name?.length < 2) {
      setError(true);
      return;
    }

    if (formState?.user_name && formState?.user_name?.length < 2) {
      setError(true);
      return;
    }

    if (formState?.mobile?.length < 8 || formState?.mobile?.length > 15) {
      setError(true);
      return;
    }

    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        // console.log("Access required");
        return;
      }

      // Create a FormData object
      const formData = new FormData();
      formData.append("name", formState?.name);
      formData.append("student_id", formState?.student_id);
      formData.append("user_name", formState?.user_name);
      formData.append("email", formState?.email);
      formData.append("mobile", formState?.mobile);
      formData.append("country_code", formState?.country_code);
      formData.append("gender", formState?.gender);
      formData.append("address", formState?.address);
      formData.append("visa_status", formState?.visa_status);
      formData.append("education", selectedEducation);
      formData.append("batch", selectedBatch);
      formData.append("selectedCountry", selectedCountry);
      formData.append("selectedState", selectedState);
      formData.append("selectedCity", selectedCity);
      formData.append("completed", isCompleted);
      // Append the image file (assuming `imagePreview` is the File object)
      const imageInput = document.querySelector("#student-image");
      if (imageInput && imageInput.files[0]) {
        formData.append("image", imageInput.files[0]);
      }

      // If editing a student

      const response = await axios.put(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/update-student/${studentToEdit?._id}`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data", // Ensure the content type is set correctly
          },
        }
      );

      if (response?.status && response?.status === 200) {
        setSnackbarMessage("Updated successfully!");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
        setTimeout(() => {
          navigate("/student-list");
        }, 2000);
      }
    } catch (err) {
      if (err?.response && err?.response?.status === 409) {
        // // console.log("409 error detected");
        setSnackbarMessage(
          "This Email ID is already exists. Please check and update accordingly."
        );
        setSnackbarSeverity("warning");
        setOpenSnackbar(true);
      } else if (err.response && err.response.status === 402) {
        setSnackbarMessage("Please fill out all required fields..");
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
      } else {
        setSnackbarMessage("Failed to update. Please try again");
        setSnackbarSeverity("error");
        setOpenSnackbar(true);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate("/student-list");
  };

  const [qualifications] = useState([
    "GCSEs (General Certificate of Secondary Education)",
    "IGCSEs (International General Certificate of Secondary Education)",
    "A-Levels (Advanced Level)",
    "AS Levels (Advanced Subsidiary Level)",
    "BTEC (Business and Technology Education Council) Level 2/3",
    "NVQs (National Vocational Qualifications)",
    "T Levels",
    "BTECs (Level 3 and higher)",
    "Foundation Degrees",
    "Bachelor’s Degrees",
    "Integrated Master’s Degrees",
    "Higher National Certificates (HNCs) and Diplomas (HNDs)",
    "PGCE (Postgraduate Certificate in Education)",
    "Master’s Degrees",
    "Doctorates",
    "Postgraduate Diplomas and Certificates",
    "IELTS (International English Language Testing System)",
    "Cambridge English Qualifications",
    "Scottish Qualifications",
    "Welsh Baccalaureate",
    "International Baccalaureate (IB)",
  ]);

  // for handle img and video
  // const handleImageChange = (e) => {
  //   const file = e.target.files[0];
  //   setCertificateImage(file);
  //   if (file) {
  //     const reader = new FileReader();
  //     reader.onloadend = () => {
  //       setImagePreviewUrl(reader.result);
  //     };
  //     reader.readAsDataURL(file);
  //   }
  // };

  const handleCheckboxChange = (course) => {
    // console.log("isCompleted: ", isCompleted);

    setIsCompleted(!isCompleted);
  };

  const handleToggleStatus = async (item, e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");
    if (!token) {
      // console.log("Access required");
      return;
    }
    try {
      const updatedStatus = !item.completed; // Toggle the current status
      const response = await axios.put(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/enrolled-course-completed-update/${item._id}`,
        { status: updatedStatus },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data", // Ensure the content type is set correctly
          },
        }
      );

      if (response.status === 200) {
        // Update the status locally
        // setCommunity((prevtrader) =>
        //   prevtrader.map((b) =>
        //     b._id === item._id ? { ...b, status: updatedStatus } : b
        //   )
        // );
        getErolledStudentById(studentToEdit._id);

        setSnackbarMessage("Course completion Status updated successfully!");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
      }
    } catch (error) {
      console.error("Failed to toggle course completed:", error);
      setSnackbarMessage(
        "Failed to update course completion status. Please try again."
      );
      setSnackbarSeverity("error");
      setOpenSnackbar(true);
    }
  };

  const handleCopy = () => {
    const textToCopy = `https://pglt=43&q=paypal&cvid=bb3beb92655f4d6d4548f7e52e3/${
      selectedCourseData?.fees || "N/A"
    }`;

    navigator.clipboard
      .writeText(textToCopy)
      .then(() => {
        setShowCopied(true);
        setTimeout(() => setShowCopied(false), 1000); // Hide after 2 seconds
      })
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  // save modal details to payment list
  const handleModalSubmit = async () => {
    if (!selectedModalCourse || !amount || !paymentMode) {
      alert("Please fill in all payment details.");
      return;
    }

    // if (paymentMode === "Finance" && !paymentProof) {
    //   alert("Please upload payment proof for Finance payment mode.");
    //   return;
    // }

    const token = localStorage.getItem("token");
    if (!token) {
      // console.log("Access required");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("courseId", selectedModalCourse.course_id);
      formData.append("details_id", studentToEdit._id);
      formData.append("amount", amount);
      formData.append("paymentMode", paymentMode);
      formData.append("dateOfPayment", new Date().toISOString());

      if (paymentProof) {
        formData.append("image", paymentProof);
      }

      const response = await axios.post(
        `${process.env.REACT_APP_INSTITUTION_BASEURL}/create-course-payment`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status === 200) {
        // alert("Payment details saved successfully!");
        setSnackbarMessage("Payment details saved successfully!");
        setSnackbarSeverity("success");
        setOpenSnackbar(true);
        getErolledStudentById(studentToEdit._id);
        setShowModal(false);
        setAmount("");
        setPaymentMode("");
        setPaymentProof(null);
      } else {
        alert(`Error: ${response.data.message}`);
      }
    } catch (error) {
      console.error("Error saving payment details:", error);
      alert("Failed to save payment details.");
    }
  };

  // modal
  const handleShowModal = (course) => {
    setSelectedModalCourse(course);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setAmount("");
    setPaymentMode("Finance");
    setPaymentProof(null);
  };

  const handleImageClick = (imageUrl) => {
    setModalImage(imageUrl);
    setShowImageModal(true);
  };

  const handleViewPaymentDetails = (course) => {
    setSelectedCoursePayments(course.payments);
    setShowPaymentDetailsModal(true);
  };

  return (
    <>
      <div className="row gy-4" style={styles.cardContent(loading)}>
        <div className="col-lg-4">
          <div className="user-grid-card position-relative border radius-16 overflow-hidden bg-base h-100">
            <div className="pb-24 ms-16 mb-24 me-16  mt-20">
              <div className="text-center border border-top-0 border-start-0 border-end-0">
                <img
                  src={
                    imagePreview ||
                    "assets/images/user-grid/user-grid-img14.png"
                  }
                  alt=""
                  className="border br-white border-width-2-px w-200-px h-200-px rounded-circle object-fit-cover"
                />
                <h6 className="mb-0 mt-16">{formState.name}</h6>
                <span className="text-secondary-light mb-16">
                  {formState.email}
                </span>
              </div>
              <div className="mt-24">
                <h6 className="text-xl mb-16">Personal Info</h6>
                <ul>
                  <li className="d-flex align-items-center gap-1 mb-12">
                    <span className="w-30 text-md fw-semibold text-primary-light">
                      Student ID
                    </span>
                    <span className="w-70 text-secondary-light fw-medium">
                      : {formState.student_id}
                    </span>
                  </li>
                  <li className="d-flex align-items-center gap-1 mb-12">
                    <span className="w-30 text-md fw-semibold text-primary-light">
                      Full Name
                    </span>
                    <span className="w-70 text-secondary-light fw-medium">
                      : {formState.name}
                    </span>
                  </li>
                  <li className="d-flex align-items-center gap-1 mb-12">
                    <span className="w-30 text-md fw-semibold text-primary-light">
                      User Name
                    </span>
                    <span className="w-70 text-secondary-light fw-medium">
                      : {formState.user_name}
                    </span>
                  </li>
                  <li className="d-flex align-items-center gap-1 mb-12">
                    <span className="w-30 text-md fw-semibold text-primary-light">
                      {" "}
                      Email
                    </span>
                    <span className="w-70 text-secondary-light fw-medium">
                      : {formState.email}
                    </span>
                  </li>
                  <li className="d-flex align-items-center gap-1 mb-12">
                    <span className="w-30 text-md fw-semibold text-primary-light">
                      {" "}
                      Phone Number
                    </span>
                    <span className="w-70 text-secondary-light fw-medium">
                      : {formState.mobile}
                    </span>
                  </li>
                  <li className="d-flex align-items-center gap-1 mb-12">
                    <span className="w-30 text-md fw-semibold text-primary-light">
                      {" "}
                      Address
                    </span>
                    <span className="w-70 text-secondary-light fw-medium">
                      : {formState.address}
                    </span>
                  </li>
                  <li className="d-flex align-items-center gap-1 mb-12">
                    <span className="w-30 text-md fw-semibold text-primary-light">
                      {" "}
                      Gender
                    </span>
                    <span className="w-70 text-secondary-light fw-medium">
                      : {formState.gender}
                    </span>
                  </li>
                  <li className="d-flex align-items-center gap-1 mb-12">
                    <span className="w-30 text-md fw-semibold text-primary-light">
                      {" "}
                      Education
                    </span>
                    <span className="w-70 text-secondary-light fw-medium">
                      : {formState.education}
                    </span>
                  </li>
                  <li className="d-flex align-items-center gap-1 mb-12">
                    <span className="w-30 text-md fw-semibold text-primary-light">
                      {" "}
                      Country
                    </span>
                    <span className="w-70 text-secondary-light fw-medium">
                      : {savedCountryName}
                    </span>
                  </li>
                  <li className="d-flex align-items-center gap-1 mb-12">
                    <span className="w-30 text-md fw-semibold text-primary-light">
                      {" "}
                      State
                    </span>
                    <span className="w-70 text-secondary-light fw-medium">
                      : {savedStateName}
                    </span>
                  </li>
                  <li className="d-flex align-items-center gap-1 mb-12">
                    <span className="w-30 text-md fw-semibold text-primary-light">
                      {" "}
                      City
                    </span>
                    <span className="w-70 text-secondary-light fw-medium">
                      : {savedCityName && savedCityName}
                    </span>
                  </li>
                  <li className="d-flex align-items-center gap-1 mb-12">
                    <span className="w-30 text-md fw-semibold text-primary-light">
                      {" "}
                      Visa Status
                    </span>
                    <span className="w-70 text-secondary-light fw-medium">
                      : {formState.visa_status}
                    </span>
                  </li>
                  <li className="d-flex align-items-center gap-1 mb-12">
                    <span className="w-30 text-md fw-semibold text-primary-light">
                      {" "}
                      Batch
                    </span>
                    <span className="w-70 text-secondary-light fw-medium">
                      : {savedBatchName}
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-8">
          <div className="card h-100">
            <div className="card-body p-24">
              <ul
                className="nav border-gradient-tab nav-pills mb-20 d-inline-flex"
                id="pills-tab"
                role="tablist"
              ></ul>

              <div className="tab-content" id="pills-tabContent">
                <div
                  className="tab-pane fade show active"
                  id="pills-edit-profile"
                  role="tabpanel"
                  aria-labelledby="pills-edit-profile-tab"
                  tabIndex={0}
                >
                  <h6 className="text-md text-primary-light mb-16">
                    Profile Image
                  </h6>
                  {/* Upload Image Start */}
                  <div className="mb-24 mt-16">
                    <div className="avatar-upload">
                      <div className="avatar-edit position-absolute bottom-0 end-0 me-24 mt-16 z-1 cursor-pointer">
                        {/* File input hidden using CSS */}
                        <input
                          type="file"
                          id="student-image"
                          accept="image/*"
                          className="d-none" // This hides the file input
                          onChange={readURL}
                        />
                        <label
                          htmlFor="student-image" // Bind label to file input
                          className="w-32-px h-32-px d-flex justify-content-center align-items-center bg-primary-20 text-primary-600 border border-primary-600 bg-hover-primary-100 text-lg rounded-circle"
                        >
                          <Icon icon="solar:camera-outline" className="icon" />
                        </label>
                      </div>
                      <div className="avatar-preview">
                        <div
                          id="imagePreview"
                          style={{
                            backgroundImage: `url(${
                              imagePreview ||
                              "assets/images/user-grid/user-grid-img14.png"
                            })`,
                            backgroundSize: "cover",
                            backgroundPosition: "center",
                          }}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Upload Image End */}
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-sm-6">
                        <div className="mb-20">
                          <label
                            htmlFor="name"
                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                          >
                            Full Name
                            <span className="text-danger-600">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control radius-8"
                            id="name"
                            name="name"
                            value={formState.name}
                            disabled={roleName === "Tutor"}
                            onChange={(e) => {
                              const regex = /^[A-Za-z\s]*$/; // Allow alphabets and spaces only
                              const value = e.target.value;
                              if (value === "" || value.trim() !== "") {
                                if (regex.test(value)) {
                                  handleInputChange(e); // Update state only if valid
                                }
                              }
                            }}
                            onBlur={() => setIsNameTouched(true)} // Mark field as touched when focus is lost
                            placeholder="Enter Full Name"
                            required
                          />
                          {isNameTouched && (
                            <>
                              {formState.name && formState.name.length < 2 && (
                                <small className="text-danger-600">
                                  Name must be at least 2 characters long
                                </small>
                              )}
                            </>
                          )}
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="mb-20">
                          <label
                            htmlFor="user_name"
                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                          >
                            User Name
                            <span className="text-danger-600">*</span>
                          </label>
                          <input
                            type="text"
                            className="form-control radius-8"
                            id="user_name"
                            name="user_name"
                            value={formState.user_name}
                            disabled={roleName === "Tutor"}
                            onChange={(e) => {
                              const value = e.target.value;
                              if (value === "" || value.trim() !== "") {
                                handleInputChange(e);
                              }
                            }}
                            onBlur={() => setIsNameTouched(true)} // Mark field as touched when focus is lost
                            placeholder="Enter User Name"
                            required
                          />
                          {isNameTouched && (
                            <>
                              {formState.user_name &&
                                formState.user_name.length < 2 && (
                                  <small className="text-danger-600">
                                    User name must be at least 2 characters long
                                  </small>
                                )}
                            </>
                          )}
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="mb-20">
                          <label
                            htmlFor="email"
                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                          >
                            Email <span className="text-danger-600">*</span>
                          </label>
                          <input
                            name="email"
                            type="email"
                            className="form-control radius-8"
                            id="email"
                            required
                            value={formState.email}
                            disabled={roleName === "Tutor"}
                            onChange={handleInputChange}
                            placeholder="Enter email address"
                          />
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="mb-20">
                          <label
                            htmlFor="address"
                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                          >
                            Address
                            {/* <span className="text-danger-600">*</span> */}
                          </label>
                          <input
                            type="text"
                            className="form-control radius-8"
                            id="address"
                            name="address"
                            value={formState.address}
                            disabled={roleName === "Tutor"}
                            onChange={(e) => {
                              const value = e.target.value;
                              if (value === "" || value.trim() !== "") {
                                handleInputChange(e);
                              }
                            }}
                            // required
                            placeholder="Enter your address"
                          />
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="mb-20">
                          <label
                            htmlFor="gender"
                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                          >
                            Gender
                            <span className="text-danger-600">*</span>
                          </label>
                          <select
                            id="gender"
                            name="gender"
                            value={formState.gender}
                            disabled={roleName === "Tutor"}
                            onChange={handleInputChange}
                            className="form-control radius-8"
                            required
                          >
                            <option value="" disabled>
                              Select Gender
                            </option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                            <option value="Others">Others</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="mb-20">
                          <label
                            htmlFor="education"
                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                          >
                            Education
                            <span className="text-danger-600">*</span>
                          </label>
                          <div className="custom-select">
                            <select
                              value={selectedEducation || ""}
                              disabled={roleName === "Tutor"}
                              onChange={(e) => {
                                const selectedValue = e.target.value;
                                setSelectedEducation(selectedValue || "");
                              }}
                              className="form-control radius-8"
                              id="country"
                              required
                            >
                              <option value="" disabled>
                                Select Education
                              </option>
                              {qualifications.map((qualification, index) => (
                                <option key={index} value={qualification}>
                                  {qualification}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="mb-20">
                          <label
                            htmlFor="country"
                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                          >
                            Country
                            {/* <span className="text-danger-600">*</span> */}
                          </label>
                          <div className="custom-select">
                            <select
                              value={selectedCountry || ""}
                              disabled={roleName === "Tutor"}
                              onChange={(e) => {
                                setSelectedState("");
                                setSelectedCity("");
                                const selectedValue = e.target.value;
                                setSelectedCountry(selectedValue || "");
                                setFormState({
                                  ...formState,
                                  country_code: countries.find(
                                    (country) =>
                                      country?._id === selectedCountry
                                  )?.phone_code,
                                });
                              }}
                              className="form-control radius-8"
                              id="country"
                              // required
                            >
                              <option value="" disabled>
                                Select Country
                              </option>
                              {countries.map((country) => (
                                <option key={country._id} value={country?._id}>
                                  {country?.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="mb-20">
                          <label
                            htmlFor="state"
                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                          >
                            State
                            {/* <span className="text-danger-600">*</span> */}
                          </label>
                          <div className="custom-select">
                            <select
                              value={selectedState || ""}
                              disabled={roleName === "Tutor"}
                              onChange={(e) => {
                                setSelectedCity("");
                                const selectedValue = e?.target?.value;
                                setSelectedState(selectedValue || "");
                              }}
                              className="form-control radius-8"
                              id="country"
                              // required
                            >
                              <option value="" disabled>
                                Select State
                              </option>
                              {states?.map((state) => (
                                <option key={state._id} value={state._id}>
                                  {state.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="mb-20">
                          <label
                            htmlFor="city"
                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                          >
                            City
                          </label>
                          <div className="custom-select">
                            <select
                              value={selectedCity || ""}
                              disabled={roleName === "Tutor"}
                              onChange={(e) => {
                                const selectedValue = e?.target.value;
                                setSelectedCity(selectedValue || "");
                              }}
                              className="form-control radius-8"
                              id="country"
                            >
                              <option value="" disabled>
                                Select City
                              </option>
                              {cities?.map((city) => (
                                <option key={city?._id} value={city?._id}>
                                  {city?.name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="mb-20">
                          <label
                            htmlFor="mobile"
                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                          >
                            Contact
                            <span className="text-danger-600">*</span>
                          </label>
                          <div className="d-flex">
                            <input
                              type="text"
                              className="form-control radius-8"
                              style={{ width: "80px", marginRight: "8px" }} // Adjust width and margin
                              id="country_code"
                              value={formState.country_code}
                              onChange={(e) => {
                                let value = e.target.value;
                                // Always start with '+'
                                if (!value.startsWith("+")) {
                                  value = "+" + value.replace(/[^0-9]/g, "");
                                } else {
                                  value =
                                    "+" + value.slice(1).replace(/[^0-9]/g, "");
                                }
                                setFormState({
                                  ...formState,
                                  country_code: value,
                                });
                              }}
                              name="country_code"
                              // readOnly // Make the field non-editable
                              placeholder="Code"
                            />
                            <input
                              type="text"
                              className="form-control radius-8"
                              id="mobile"
                              name="mobile"
                              value={formState.mobile}
                              disabled={roleName === "Tutor"}
                              onChange={(e) => {
                                const regex = /^[0-9]*$/; // Allow numbers only
                                const value = e.target.value;

                                if (
                                  (regex.test(value) || value === "") &&
                                  value.length <= 15 // Enforce max length
                                ) {
                                  handleInputChange(e); // Update state only if valid
                                }
                              }}
                              onBlur={() => {
                                setIsMobileTouched(true); // Mark field as touched when focus is lost
                                if (
                                  formState.mobile.length < 8 ||
                                  formState.mobile.length > 15
                                ) {
                                  setError(
                                    "Contact number must be between 8 and 15 digits."
                                  );
                                } else {
                                  setError(""); // Clear error if valid
                                }
                              }}
                              placeholder="Enter your contact number"
                              maxLength={15} // Ensure no more than 15 characters
                              required
                            />
                          </div>
                          {isMobileTouched && formState.mobile && error && (
                            <small className="text-danger-600">{error}</small>
                          )}
                        </div>
                      </div>
                      <div className="col-sm-6">
                        <div className="mb-20">
                          <label
                            htmlFor="visa_status"
                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                          >
                            Visa Status
                            <span className="text-danger-600">*</span>
                          </label>
                          <select
                            id="visa_status"
                            name="visa_status"
                            value={formState.visa_status}
                            disabled={roleName === "Tutor"}
                            onChange={handleInputChange}
                            className="form-control radius-8"
                            required
                          >
                            <option value="" disabled>
                              Select Visa Status
                            </option>
                            <option value="British Citizen">
                              British Citizen
                            </option>
                            <option value="Student">Student</option>
                            <option value="Other">Other</option>
                          </select>
                        </div>
                      </div>
                      {/* <div className="col-sm-6">
                        <div className="mb-20">
                          <label
                            htmlFor="batch"
                            className="form-label fw-semibold text-primary-light text-sm mb-8"
                          >
                            Select Batch
                            <span className="text-danger-600">*</span>
                          </label>
                          <select
                            className="form-control radius-8 form-select"
                            id="batch"
                            required
                            value={selectedBatch || ""}
                            disabled={roleName === 'Tutor'}
                            onChange={(e) =>
                              setSelectedBatch(e.target.value || "")
                            }
                          >
                            <option value="" disabled>
                              Select Batch
                            </option>
                            {batches.ongoing?.length > 0 ||
                            batches.upcoming?.length > 0 ? (
                              [
                                ...(batches.ongoing || []),
                                ...(batches.upcoming || []),
                              ].map((batch) => (
                                <option key={batch._id} value={batch._id}>
                                  {batch?.batch_name} [
                                  {batch?.course_id?.coursename}]
                                  {batch.batch_start_duration <=
                                  new Date().toISOString()
                                    ? " (Ongoing)"
                                    : " (Upcoming)"}
                                </option>
                              ))
                            ) : (
                              <option value="" disabled>
                                No batches available
                              </option>
                            )}
                          </select>
                        </div>
                      </div> */}
                      {/* payment link */}
                      {/* {roleName === "Admin" && (
                        <button
                          type="button"
                          className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8 mb-2"
                          onClick={handleCopy}
                        >
                          <span>
          //                    https://pglt=43&q=paypal&cvid=bb3beb92655f4d6d4548f7e52e3/
          // {selectedCourseData.fees} 
                            Payment link
                          </span>
                        </button>
                      )} */}
                      {/* Copied Notification Box */}
                      {showCopied && (
                        <div className="absolute top-0 left-1/2 -translate-x-1/2 mt-2 bg-green-500 text-white text-sm py-1 px-3 rounded-md shadow-lg z-50 transition-opacity duration-300">
                          Copied!
                        </div>
                      )}

                      {roleName === "Admin" && (
                        <div className="d-flex align-items-center justify-content-center gap-3 mt-3">
                          <button
                            type="button"
                            className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-56 py-11 radius-8"
                            onClick={handleCancel}
                          >
                            Cancel
                          </button>
                          <button
                            type="submit"
                            className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
                          >
                            {loading && (
                              <div
                                className="loader-container"
                                style={styles.loaderContainer}
                              >
                                <CircularProgress />
                              </div>
                            )}
                            Save
                          </button>
                        </div>
                      )}
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Modal */}
        <Modal show={showModal} onHide={handleCloseModal} centered>
          <Modal.Header closeButton>
            <Modal.Title>Enter Payment Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              <Form.Group className="mb-3">
                <Form.Label>Amount</Form.Label>
                <Form.Control
                  type="number"
                  value={amount}
                  onChange={(e) => setAmount(e.target.value)}
                  placeholder="Enter amount"
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Payment Mode</Form.Label>
                <div>
                  <Form.Check
                    type="radio"
                    label="Finance"
                    name="paymentMode"
                    value="Finance"
                    checked={paymentMode === "Finance"}
                    onChange={(e) => setPaymentMode(e.target.value)}
                  />
                  <Form.Check
                    type="radio"
                    label="Bank Transfer"
                    name="paymentMode"
                    value="Bank Transfer"
                    checked={paymentMode === "Bank Transfer"}
                    onChange={(e) => setPaymentMode(e.target.value)}
                  />
                  <Form.Check
                    type="radio"
                    label="Payment by link"
                    name="paymentMode"
                    value="Payment by link"
                    checked={paymentMode === "Payment by link"}
                    onChange={(e) => setPaymentMode(e.target.value)}
                  />
                </div>
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Payment Proof</Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*"
                  onChange={(e) => setPaymentProof(e.target.files[0])}
                  placeholder="Upload payment proof"
                />
                {paymentProof && (
                  <img
                    src={URL.createObjectURL(paymentProof)}
                    alt="Payment Proof Preview"
                    className="mt-2"
                    style={{ maxWidth: "100%", maxHeight: "200px" }}
                  />
                )}
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              type="button"
              variant="secondary"
              onClick={handleCloseModal}
            >
              Cancel
            </Button>
            <Button
              type="button"
              variant="primary"
              onClick={handleModalSubmit}
              // disabled={!paymentProof}
            >
              Submit
            </Button>
          </Modal.Footer>
        </Modal>

        {/* Image Modal */}
        {/* <Modal show={showImageModal} onHide={() => setShowImageModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>Image Preview</Modal.Title>
          </Modal.Header>
          <Modal.Body className="d-flex justify-content-center align-items-center">
            <img
              src={modalImage}
              alt="Preview"
              className="img-fluid"
              style={{ maxHeight: '400px', width: 'auto' }}
            />
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowImageModal(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal> */}

        {/* snackbar */}
        <Modal
          show={showImageModal}
          onHide={() => setShowImageModal(false)}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>Payment Proof</Modal.Title>
          </Modal.Header>
          <Modal.Body className="text-center">
            <img
              src={modalImage}
              alt="Payment Proof"
              style={{ maxWidth: "100%", maxHeight: "80vh" }}
            />
          </Modal.Body>
        </Modal>

        <Snackbar
          open={openSnackbar}
          autoHideDuration={3000}
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
        >
          <Alert onClose={handleCloseSnackbar} severity={snackbarSeverity}>
            {snackbarMessage}
          </Alert>
        </Snackbar>

        {/* Payment Details Modal */}
        <Modal
          show={showPaymentDetailsModal}
          onHide={() => setShowPaymentDetailsModal(false)}
          size="lg"
        >
          <Modal.Header closeButton>
            <Modal.Title>Payment Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="table-responsive">
              <table className="table bordered-table sm-table mb-0">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Amount</th>
                    <th>Date</th>
                    <th>Mode</th>
                    <th>Proof</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedCoursePayments &&
                  selectedCoursePayments.length > 0 ? (
                    selectedCoursePayments.map((payment, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{payment.payment_amount}</td>
                        <td>
                          {payment?.payment_date
                            ? new Date(
                                payment?.payment_date
                              ).toLocaleDateString()
                            : "-"}
                        </td>
                        <td>{payment.payment_mode}</td>
                        <td>
                          {payment.payment_proof ? (
                            <button
                              className="btn btn-link"
                              onClick={() =>
                                handleImageClick(payment.payment_proof)
                              }
                            >
                              View Proof
                            </button>
                          ) : (
                            "No proof available"
                          )}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-center">
                        No payment details available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => setShowPaymentDetailsModal(false)}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      <div className="row mt-5">
        <div className="accordion" id="dashboardAccordion">
          {/* Course Details Accordion Item */}
          {roleName === "Admin" && (
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingCourseDetails">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseCourseDetails"
                  aria-expanded="false"
                  aria-controls="collapseCourseDetails"
                >
                  <h5 className="mb-0">Course Details</h5>
                </button>
              </h2>
              <div
                id="collapseCourseDetails"
                className="accordion-collapse collapse"
                aria-labelledby="headingCourseDetails"
                data-bs-parent="#dashboardAccordion"
              >
                <div className="accordion-body">
                  <div className="card-body py-24">
                    <div className="table-responsive scroll-sm">
                      <table className="table bordered-table sm-table mb-0">
                        <thead>
                          <tr>
                            <th scope="col">
                              <div className="d-flex align-items-center gap-10">
                                S.L
                              </div>
                            </th>
                            <th scope="col">Attendance</th>
                            <th scope="col">Course Name</th>
                            <th scope="col">Batch Details</th>
                            <th scope="col">Payment Details</th>
                            <th scope="col">Course Completion</th>
                            <th scope="col">Certificate</th>
                          </tr>
                        </thead>
                        <tbody>
                          {enrolledCourseData.length > 0 ? (
                            enrolledCourseData.map((course, index) => (
                              <tr key={course?._id}>
                                <td>{index + 1}</td>
                                <td>{course?.attendance_count}</td>
                                <td>{course?.course_name}</td>
                                <td>
                                  <div className="d-flex flex-column gap-2">
                                    {/* <span>{course?.batch_brief || 'No batch assigned'}</span> */}
                                    {roleName === "Admin" && (
                                      <select
                                        className="form-select radius-8"
                                        value={course?.batch_id || ""}
                                        onChange={(e) =>
                                          handleBatchAssigning(
                                            course?._id,
                                            e.target.value
                                          )
                                        }
                                      >
                                        <option value="">Select Batch</option>
                                        {course?.batches.ongoing?.length > 0 ||
                                        course?.batches.upcoming?.length > 0 ? (
                                          [
                                            ...(course.batches.ongoing || []),
                                            ...(course.batches.upcoming || []),
                                          ].map((batch) => (
                                            <option
                                              key={batch._id}
                                              value={batch._id}
                                            >
                                              {batch?.batch_name}
                                              {batch.batch_start_duration <=
                                              new Date().toISOString()
                                                ? " (Ongoing)"
                                                : " (Upcoming)"}
                                            </option>
                                          ))
                                        ) : (
                                          <option value="" disabled>
                                            No batches available
                                          </option>
                                        )}
                                      </select>
                                    )}
                                  </div>
                                </td>
                                <td>
                                  <span className="text-md mb-0 fw-normal text-secondary-light">
                                    <br />
                                    {"Total amount paid:  "}
                                    {course?.total_amount_paid}
                                    <br />
                                    <br />
                                    <div className="d-flex gap-2">
                                      <button
                                        type="button"
                                        className="btn btn-info"
                                        onClick={() =>
                                          handleViewPaymentDetails(course)
                                        }
                                      >
                                        View Details
                                      </button>
                                      <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={() => handleShowModal(course)}
                                      >
                                        + Add Payment
                                      </button>
                                    </div>
                                  </span>
                                </td>
                                <td>
                                  {Date.now() >
                                    new Date(
                                      selectedBatchStartDate
                                    ).getTime() &&
                                  Date.now() <
                                    new Date(selectedBatchToDate).getTime() ? (
                                    <span>Ongoing batch</span>
                                  ) : (
                                    <button
                                      onClick={(e) => {
                                        handleToggleStatus(course, e);
                                        getErolledStudentById(
                                          studentToEdit._id
                                        );
                                      }}
                                      type="button"
                                      className={`bg-${
                                        course?.completed ? "success" : "danger"
                                      }-focus text-${
                                        course?.completed ? "success" : "danger"
                                      }-600 border border-${
                                        course?.completed ? "success" : "danger"
                                      }-main px-24 py-4 radius-4 fw-medium text-sm`}
                                    >
                                      {course?.completed
                                        ? "Completed"
                                        : "Not Completed"}
                                    </button>
                                  )}
                                </td>
                                <td>
                                  {course?.completed && (
                                    <div className="mb-20">
                                      <div className="upload-field d-flex flex-column">
                                        <input
                                          type="file"
                                          id={`certificateImage-${course._id}`}
                                          accept="image/*"
                                          onChange={(e) =>
                                            handleImageChange(e, course._id)
                                          }
                                          className="d-none"
                                        />
                                        <button
                                          type="button"
                                          onClick={() =>
                                            document
                                              .getElementById(
                                                `certificateImage-${course._id}`
                                              )
                                              .click()
                                          }
                                          className="btn btn-outline-primary"
                                        >
                                          <i className="fas fa-upload me-2"></i>{" "}
                                          Upload Certificate
                                        </button>
                                        {imagePreviews[course._id] ? (
                                          <img
                                            src={imagePreviews[course._id]}
                                            alt="Certificate Preview"
                                            className="img-thumbnail mt-2"
                                            style={{ maxHeight: "100px" }}
                                          />
                                        ) : course?.certificateImage ? (
                                          <img
                                            src={course?.certificateImage}
                                            alt="Certificate Preview"
                                            className="img-thumbnail mt-2"
                                            style={{ maxHeight: "100px" }}
                                          />
                                        ) : null}
                                      </div>
                                    </div>
                                  )}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="7" className="text-center">
                                No course details found
                              </td>
                            </tr>
                          )}
                          <tr>
                            <td colSpan="7" className="text-center">
                              <button
                                type="button"
                                className="btn btn-success"
                                onClick={() => setShowCourseModal(true)}
                                disabled={
                                  Array.isArray(enrolledCourseData) &&
                                  enrolledCourseData.some(
                                    (course) => !course?.completed
                                  )
                                }
                                title={
                                  Array.isArray(enrolledCourseData) &&
                                  enrolledCourseData.some(
                                    (course) => !course?.completed
                                  )
                                    ? "Complete existing courses before adding new ones"
                                    : ""
                                }
                              >
                                <i className="fas fa-plus me-2"></i>
                                Add New Course
                              </button>
                            </td>
                          </tr>
                        </tbody>

                        {/* Course List Modal */}
                        <Modal
                          show={showCourseModal}
                          onHide={() => setShowCourseModal(false)}
                          size="lg"
                        >
                          <Modal.Header closeButton>
                            <Modal.Title>Available Courses</Modal.Title>
                          </Modal.Header>
                          <Modal.Body>
                            <div className="table-responsive">
                              <table className="table bordered-table sm-table mb-0">
                                <thead>
                                  <tr>
                                    <th>#</th>
                                    <th>Course Name</th>
                                    <th>Description</th>
                                    <th>Price</th>
                                    <th>Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {Array.isArray(availableCourses) &&
                                    availableCourses.map((course, index) => (
                                      <tr key={course?._id || index}>
                                        <td>{index + 1}</td>
                                        <td>{course?.coursename}</td>
                                        <td>{course?.description}</td>
                                        <td>
                                          {"$ "}
                                          {course?.fees}
                                        </td>
                                        <td>
                                          <button
                                            type="button"
                                            className="btn btn-primary btn-sm"
                                            onClick={() =>
                                              handlePurchaseCourse(course._id)
                                            }
                                            disabled={
                                              purchaseLoading === course._id
                                            }
                                          >
                                            {purchaseLoading === course._id ? (
                                              <span
                                                className="spinner-border spinner-border-sm me-1"
                                                role="status"
                                                aria-hidden="true"
                                              ></span>
                                            ) : null}
                                            Purchase
                                          </button>
                                        </td>
                                      </tr>
                                    ))}
                                  {(!Array.isArray(availableCourses) ||
                                    availableCourses.length === 0) && (
                                    <tr>
                                      <td colSpan="5" className="text-center">
                                        No courses available
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                          </Modal.Body>
                          <Modal.Footer>
                            <Button
                              variant="secondary"
                              onClick={() => setShowCourseModal(false)}
                            >
                              Close
                            </Button>
                          </Modal.Footer>
                        </Modal>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
          {roleName === "Admin" && (
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingReferralDetails">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseReferralDetails"
                  aria-expanded="false"
                  aria-controls="collapseReferralDetails"
                >
                  <h5 className="mb-0">Referral Details</h5>
                </button>
              </h2>
              <div
                id="collapseReferralDetails"
                className="accordion-collapse collapse"
                aria-labelledby="headingCourseDetails"
                data-bs-parent="#dashboardAccordion"
              >
                <div className="accordion-body">
                  <div className="card-body py-24">
                    <h6 className="text-md text-primary-light mb-16">
                      Student Referral Details
                    </h6>
                    <div className="table-responsive scroll-sm">
                      <table className="table bordered-table sm-table mb-0">
                        <thead>
                          <tr>
                            <th scope="col">
                              <div className="d-flex align-items-center gap-10">
                                S.L
                              </div>
                            </th>
                            <th scope="col">Student name</th>
                            <th scope="col">Course Name</th>
                            <th scope="col">Total Amount Earned</th>
                          </tr>
                        </thead>
                        <tbody>
                          {refferal?.studentReferralss?.length > 0 ? (
                            refferal.studentReferralss.map((course, index) => (
                              <tr key={course?._id}>
                                <td>{index + 1}</td>
                                <td>{course?.name}</td>
                                <td>
                                  {course?.billing_details?.map(
                                    (bill, billIndex) => (
                                      <ul
                                        className="course-names-list"
                                        key={`bill-${billIndex}`}
                                      >
                                        <li className="course-name-item">
                                          {bill?.course_id?.coursename}
                                        </li>
                                      </ul>
                                    )
                                  )}
                                </td>
                                <td>
                                  {course?.studTotalReferralssAmount || "0"}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="4" className="text-center">
                                No referral details found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="card-body py-24">
                    <h6 className="text-md text-primary-light mb-16">
                      Trader Referral Details
                    </h6>
                    <div className="table-responsive scroll-sm">
                      <table className="table bordered-table sm-table mb-0">
                        <thead>
                          <tr>
                            <th scope="col">
                              <div className="d-flex align-items-center gap-10">
                                S.L
                              </div>
                            </th>
                            <th scope="col">Trader name</th>
                            <th scope="col">Membership Name</th>
                            <th scope="col">Total Amount Earned</th>
                          </tr>
                        </thead>
                        <tbody>
                          {refferal?.TraderReferralss?.length > 0 ? (
                            refferal.TraderReferralss.map((course, index) => (
                              <tr key={course?._id}>
                                <td>{index + 1}</td>
                                <td>{course?.name}</td>
                                <td>
                                  {course?.billing_details?.map(
                                    (bill, billIndex) => (
                                      <ul
                                        className="course-names-list"
                                        key={`bill-${billIndex}`}
                                      >
                                        <li className="course-name-item">
                                          {bill?.membership_id?.title}
                                        </li>
                                      </ul>
                                    )
                                  )}
                                </td>
                                <td>
                                  {course?.traderTotalReferralssAmount || "0"}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="4" className="text-center">
                                No referral details found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Zoom Attendance Accordion Item */}
          {(roleName === "Admin" || roleName === "Tutor") && (
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingZoomAttendance">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseZoomAttendance"
                  aria-expanded="false"
                  aria-controls="collapseZoomAttendance"
                >
                  <h5 className="mb-0">Zoom Attendance</h5>
                </button>
              </h2>
              <div
                id="collapseZoomAttendance"
                className="accordion-collapse collapse"
                aria-labelledby="headingZoomAttendance"
                data-bs-parent="#dashboardAccordion"
              >
                <div className="accordion-body">
                  <div className="card-body py-24">
                    <div className="table-responsive scroll-sm">
                      <table className="table bordered-table sm-table mb-0">
                        <thead>
                          <tr>
                            <th scope="col">Batch</th>
                            <th scope="col">Attendance</th>
                            <th scope="col">Attendance Needed</th>
                          </tr>
                        </thead>
                        <tbody>
                          {attendences && attendences.length > 0 ? (
                            attendences.map((attendence) => (
                              <tr key={attendence._id}>
                                <td>{attendence.batch_name}</td>
                                <td>{attendence.attendanceCount}</td>
                                <td>{attendence.daysBetween}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="3" className="text-center">
                                No Attendance found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Uploaded Assessment Accordion Item */}
          {(roleName === "Admin" || roleName === "Tutor") && (
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingUploadedAssessment">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseUploadedAssessment"
                  aria-expanded="false"
                  aria-controls="collapseUploadedAssessment"
                >
                  <h5 className="mb-0">Uploaded Assessment</h5>
                </button>
              </h2>
              <div
                id="collapseUploadedAssessment"
                className="accordion-collapse collapse"
                aria-labelledby="headingUploadedAssessment"
                data-bs-parent="#dashboardAccordion"
              >
                <div className="accordion-body">
                  <div className="card-body py-24">
                    <div className="table-responsive scroll-sm">
                      <table className="table bordered-table sm-table mb-0">
                        <thead>
                          <tr>
                            <th scope="col">Date</th>
                            <th scope="col">Type</th>
                            <th scope="col">File Name</th>
                            <th scope="col">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {asessments && asessments.length > 0 ? (
                            asessments.map((assessment) => (
                              <tr key={assessment._id}>
                                <td>
                                  {new Date(
                                    assessment.createdAt
                                  ).toLocaleDateString()}
                                </td>
                                <td>Assessment File</td>
                                <td>{assessment.file_name}</td>
                                <td>
                                  <a
                                    href={assessment.pdf_file}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-sm btn-primary"
                                  >
                                    View Assessment
                                  </a>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="4" className="text-center">
                                No assessments found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Uploaded Portfolios Accordion Item */}
          {(roleName === "Admin" || roleName === "Tutor") && (
            <div className="accordion-item">
              <h2 className="accordion-header" id="headingUploadedPortfolios">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseUploadedPortfolios"
                  aria-expanded="false"
                  aria-controls="collapseUploadedPortfolios"
                >
                  <h5 className="mb-0">Uploaded Portfolios</h5>
                </button>
              </h2>
              <div
                id="collapseUploadedPortfolios"
                className="accordion-collapse collapse"
                aria-labelledby="headingUploadedPortfolios"
                data-bs-parent="#dashboardAccordion"
              >
                <div className="accordion-body">
                  <div className="card-body py-24">
                    <div className="table-responsive scroll-sm">
                      <table className="table bordered-table sm-table mb-0">
                        <thead>
                          <tr>
                            <th scope="col">Date</th>
                            <th scope="col">Type</th>
                            <th scope="col">File Name</th>
                            <th scope="col">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {portfolios && portfolios.length > 0 ? (
                            portfolios.map((portfolio) => (
                              <tr key={portfolio._id}>
                                <td>
                                  {new Date(
                                    portfolio.createdAt
                                  ).toLocaleDateString()}
                                </td>
                                <td>Portfolio File</td>
                                <td>{portfolio.file_name}</td>
                                <td>
                                  <a
                                    href={portfolio.pdf_file}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="btn btn-sm btn-primary"
                                  >
                                    View Assessment
                                  </a>
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="4" className="text-center">
                                No portfolios found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

// Add CSS for loader
const styles = {
  loaderContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    zIndex: 1000,
  },
  cardContent: (loading) => ({
    opacity: loading ? 0.5 : 1,
  }),
};

export default EditStudent;
